import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useBatmanAuth } from '../context/BatmanAuthContext';
import { LogoIcon } from './Logo';

const UserNavbar = () => {
  const { isAuthenticated, logout } = useBatmanAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#222222]/5 backdrop-blur-xl border-b border-white/10">
      <div className="w-full px-4 sm:px-6 md:px-12 lg:px-20 py-4 md:py-6 flex items-center justify-between">
        <Link to={isAuthenticated ? '/dashboard' : '/login'} className="flex items-center gap-2 text-white">
          <LogoIcon className="h-8 w-8" />
        </Link>

        <div className="flex items-center gap-2">
          {isAuthenticated ? (
            <>
              <Link to="/dashboard" className="px-3 py-2 text-sm text-white/70 hover:text-white hover:bg-white/10 transition-colors">Dashboard</Link>
              <Link to="/pricing" className="px-3 py-2 text-sm text-white/70 hover:text-white hover:bg-white/10 transition-colors">Pricing</Link>
              <button
                onClick={handleLogout}
                className="inline-flex items-center gap-2 px-3 py-2 text-sm text-white/70 hover:text-white hover:bg-white/10 transition-colors"
              >
                <LogOut className="h-4 w-4" />
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="px-3 py-2 text-sm text-white/70 hover:text-white hover:bg-white/10 transition-colors">Login</Link>
              <Link to="/signup" className="px-3 py-2 text-sm bg-white text-black hover:bg-white/90 transition-colors">Sign Up</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default UserNavbar;
